import { render, staticRenderFns } from "./UpdateAddressModal.vue?vue&type=template&id=09f7116c"
import script from "./UpdateAddressModal.vue?vue&type=script&lang=js"
export * from "./UpdateAddressModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports